import { TransactionApi } from '@/api/transaction'

const state = () => ({
    webinarPackage: [],
    loadingWebinarPackage: false,
    messageWebinarPackage: '',
    successWebinarPackage: true,
})

const getters = {
    webinarPackage: state => state.webinarPackage,
    loadingWebinarPackage: state => state.loadingWebinarPackage,
    messageWebinarPackage: state => state.messageWebinarPackage,
    successWebinarPackage: state => state.successWebinarPackage,
}

const actions = {
    async fetchAllWebinarPackage({ commit }) {
        commit('setLoadingWebinarPackage', true)
        await TransactionApi.getPackageTopup()
        .then(res => {
            commit('setLoadingWebinarPackage', false)
            commit('setWebinarPackage', res.data.data)
        })
        .catch(err => {
            commit('setMessageWebinarPackage', err.errors[0].message)
            commit('setLoadingWebinarPackage', false)
        })
    },
    async addPackageTopup({ commit }, payload) {
        await TransactionApi.addPackageTopup(payload)
        .then(res => {
            if (res.data.success) {
                commit('setMessageWebinarPackage', 'Berhasil Menambahkan Paket')
                commit('setSuccessWebinarPackage', true)
            } else {
                commit('setMessageWebinarPackage', 'Terjadi Kesalahan')
                commit('setSuccessWebinarPackage', false)
            }
        })
        .catch(err => {
            commit('setMessageWebinarPackage', err.errors[0].message)
            commit('setSuccessWebinarPackage', false)
        })
    },
    async updatePackageTopup({ commit }, data) {
        const id = data.id
        const payload = data.payload
        await TransactionApi.updatePackageTopup(id, payload)
        .then(res => {
            if (res.data.success) {
                commit('setMessageWebinarPackage', 'Berhasil Mengubah Paket')
                commit('setSuccessWebinarPackage', true)
            } else {
                commit('setMessageWebinarPackage', 'Terjadi Kesalahan')
                commit('setSuccessWebinarPackage', false)
            }
        })
        .catch(err => {
            commit('setMessageWebinarPackage', err.errors[0].message)
            commit('setSuccessWebinarPackage', false)
        })
    },
    async addPackageTopupV2({ commit }, payload) {
        await TransactionApi.addPackageTopupV2(payload)
        .then(res => {
            if (res.data.success) {
                commit('setMessageWebinarPackage', 'Berhasil Menambahkan Paket')
                commit('setSuccessWebinarPackage', true)
            } else {
                commit('setMessageWebinarPackage', 'Terjadi Kesalahan')
                commit('setSuccessWebinarPackage', false)
            }
        })
        .catch(err => {
            commit('setMessageWebinarPackage', err.errors[0].message)
            commit('setSuccessWebinarPackage', false)
        })
    },
    async updatePackageTopupV2({ commit }, data) {
        const id = data.id
        const payload = data.payload
        await TransactionApi.updatePackageTopupV2(id, payload)
        .then(res => {
            if (res.data.success) {
                commit('setMessageWebinarPackage', 'Berhasil Mengubah Paket')
                commit('setSuccessWebinarPackage', true)
            } else {
                commit('setMessageWebinarPackage', 'Terjadi Kesalahan')
                commit('setSuccessWebinarPackage', false)
            }
        })
        .catch(err => {
            commit('setMessageWebinarPackage', err.errors[0].message)
            commit('setSuccessWebinarPackage', false)
        })
    },
    async deletePackageTopup({ commit }, id) {
        await TransactionApi.deletePackageTopup(id)
        .then(res => {
            if (res.data.ok) {
                commit('setMessageWebinarPackage', 'Berhasil Menghapus Paket')
                commit('setSuccessWebinarPackage', true)
            } else {
                commit('setMessageWebinarPackage', 'Terjadi Kesalahan')
                commit('setSuccessWebinarPackage', false)
            }
        })
        .catch(err => {
            commit('setMessageWebinarPackage', err.errors[0].message)
            commit('setSuccessWebinarPackage', false)
        })
    },
}

const mutations = {
    setWebinarPackage: (state, data) => {
        state.webinarPackage = data
    },
    setLoadingWebinarPackage: (state, loading) => {
        state.loadingWebinarPackage = loading
    },
    setMessageWebinarPackage: (state, message) => {
        state.messageWebinarPackage = message
    },
    setSuccessWebinarPackage: (state, status) => {
        state.successWebinarPackage = status
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}